import "../App.css";
import Select from "react-select";
import { Button, Card, Carousel, Col, Row, Table } from "react-bootstrap";
import commercial from "../Assets/images/commercial.jpg";
import invest from "../Assets/images/investment.jpg";
import credit from "../Assets/images/credit.jpg";
import online from "../Assets/images/online.jpg";
import central from "../Assets/images/central.jpg";
import community from "../Assets/images/community.jpg";
import core from "../Assets/images/core.jpg";
import dollar from "../Assets/images/dollar.png";
import investmentbank from "../Assets/images/inv2.png";
import mobile from "../Assets/images/mobile-app.svg";
import phone from "../Assets/images/phone-call.svg";
import notepad from "../Assets/images/notepad.svg";
import Footer from "./Footer";
import coin from "../Assets/images/coin.png";
import rupee from "../Assets/images/rupee.png";
// import Model from "./Model";
import { useEffect, useState } from "react";
import balance from "../Assets/images/smartphone.svg";
import bank from "../Assets/images/bank4.svg";
// import calender from '../Assets/images/calender4.svg'
import money from "../Assets/images/money.svg";
import Custommodel from "./Custommodel";
import { ReactComponent as Calender } from "../Assets/images/calendar.svg";
import { options, technology, loan, investment } from "./Array";
import InfoCard from "./InfoCard";
import vector from '../Assets/images/bank vector.png'
import { useLocation, useNavigate } from "react-router";
import { scroller } from "react-scroll";

function Home() {
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
 const location = useLocation();
 const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      scroller.scrollTo(location.state.scrollTo, {
        smooth: true,
        duration: 500,
        offset: -70,
      });
    }
  }, [location.state]);
   const handleBankSelect = (selectedOption) => {
    setSelectedBank(selectedOption);
    
    // Scroll to InfoCard section after a short delay to ensure state update
    setTimeout(() => {
      scroller.scrollTo('info-card-section', {
        smooth: true,
        duration: 200,
        offset: -600, // Adjust this value based on your header height
      });
    }, 100);
  };

  return (
    <>
     {/* <div className="banner d-flex align-items-center justify-content-between">
      <div className="container">
      <Row className=" d-flex align-items-center justify-content-between">
        <Col lg={6} md={12} sm={12} >
        <div>
          <h1 className="text-white heading"> All Indian Bank Services <br /> in One Place</h1>
          <h5 className="text-white mt-4 h4">
                Easily check your bank balance, mini statement,customer care & more for  <br /> 50+ Indian banks.
              </h5>
              <p className="text-white mt-4">
                Discover comprehensive banking services, financial products, and{" "}
                <br />
                expert guidance for all your financial needs
              </p>
               <div className="w-full sm:w-[450px] mt-4 cursor-pointer pb-2">
                <Select
                  options={options}
                  placeholder="Select Your Bank"
                  isSearchable={true} // Enables search
                  isClearable={true}
                  value={selectedBank}
                  onChange={(selectedOption) => setSelectedBank(selectedOption)}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "8px",
                    }),
                    menu: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      width: "100%",
                      overflowY: "auto",
                      borderRadius: "8px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      "& svg": {
                        width: "30px", // Increase width
                        height: "30px", // Increase height
                      },
                    }),
                  }}
                />
              </div>
        </div>
        </Col>
        <Col lg={5} md={12} sm={12}>
        <img src={vector} className="float-animation bank-vector"  alt="" />
        </Col>
      </Row>
      </div>
     </div> */}
      <div className="banner d-flex align-items-center" id="home">
        <div id="home" className="container text-start content-div">
          <Row className="d-flex align-items-center  main-row">
            <Col lg={{ span: 6, order: 1 }} md={{ span: 11, order: 2 }} sm={{ span: 12, order: 2 }}  xs={{ order: 2 }}>
            <div className="content-inner-div">
              <div className="main-des">
              <h1 className="text-white heading">
               Banking Information Platform 
              </h1>
              <h5 className="text-white mt-4 h4">
                Easily check your bank balance, mini statement,customer care & more for  <br /> 50+ Indian banks.
              </h5>
              <p className="text-white mt-4">
                Discover comprehensive banking services, financial products, and{" "}
                <br />
                expert guidance for all your financial needs
              </p>
              </div>
              <div className="w-full sm:w-[450px] mt-4 cursor-pointer pb-2">
                <Select
                  options={options}
                  placeholder="Select Your Bank"
                  isSearchable={true} // Enables search
                  isClearable={true}
                  value={selectedBank}
                  // onChange={(selectedOption) => setSelectedBank(selectedOption)}
                  onChange={handleBankSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "8px",
                    }),
                    menu: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      width: "100%",
                      overflowY: "auto",
                      borderRadius: "8px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      "& svg": {
                        width: "30px", // Increase width
                        height: "30px", // Increase height
                      },
                    }),
                  }}
                />
              </div>
              </div>
            </Col>
            <Col  lg={{ span: 5, order: 2 }} md={{ span: 9, order: 1 }} sm={{ span: 12, order: 1 }}  xs={{ order: 1 }} className="img-col order-md-1 ">
            <img src={vector} className="float-animation bank-vector"  alt="" />
            </Col>
          </Row>
        </div>
      </div>

      

      <div className="container main-div">
        {/* <Button variant="primary" onClick={() => setModalShow(true)}>
        Launch vertically centered modal
      </Button> */}
        {/* <Row className="d-flex  justify-content-center">
          <Col lg={3} md={5} sm={12}>
            <Card className="card card2 " onClick={() => setModalShow(true)}>
              <div className="img-div">
                <img
                  className="card-img1"
                  style={{ height: "40px" }}
                  src={balance}
                  alt=""
                />
              </div>
              <div className="card-body d-flex align-items-center justify-content-center">
                <Card.Title>Bank Balance</Card.Title>
                <Card.Text className="mt-3"></Card.Text>
              </div>
            </Card>
          </Col>
          <Col lg={3} md={5} sm={12}>
            <Card className="card card2">
              <div className="img-div">
                <img
                  className="card-img1"
                  style={{ height: "40px" }}
                  src={bank}
                  alt=""
                />
              </div>
              <div className="card-body d-flex align-items-center justify-content-center">
                <Card.Title>Net Banking</Card.Title>
                <Card.Text className="mt-3"></Card.Text>
              </div>
            </Card>
          </Col>
          <Col lg={3} md={5} sm={12}>
            <Card className="card card2" onClick={() => setShow(true)}>
              <div className="img-div">
                <img
                  className="card-img1"
                  style={{ height: "40px" }}
                  src={money}
                  alt=""
                />
              </div>
              <div className="card-body d-flex align-items-center justify-content-center">
                <Card.Title>EPF Balance</Card.Title>
                <Card.Text className="mt-3"></Card.Text>
              </div>
            </Card>
          </Col>
          <Col lg={3} md={5} sm={12}>
            <Card className="card card2 ">
              <div className="img-div">
                <Calender className="card-img1" style={{ height: "35px" }} />
              </div>
              <div className="card-body d-flex align-items-center justify-content-center">
                <Card.Title>Bank Holiday</Card.Title>
                <Card.Text className="mt-3"></Card.Text>
              </div>
            </Card>
          </Col>
        </Row> */}

        {/* <Model show={modalShow} onHide={() => setModalShow(false)} />
        <Custommodel show={show} onHide={() => setShow(false)} /> */}
        <div id="info-card-section">
        <InfoCard selectedBank={selectedBank} setSelectedBank={setSelectedBank}/>
        </div>
      </div>

      <div className="container main-div text-center">
        <h1 className="h-tag ">Banking Industry Overview</h1>
        <p className="mt-5">
          The banking industry serves as the backbone of the global economy,
          facilitating financial transactions, providing credit, and managing
          monetary systems. Banks operate under strict regulatory frameworks to
          ensure stability and protect consumers. The sector has evolved
          significantly with technological advancement, offering innovative
          digital solutions while maintaining traditional banking principles.
        </p>
        <p className="mt-5">
          Modern banking encompasses various specialized services including
          retail banking, corporate banking, investment banking, and private
          banking. Each sector serves distinct customer segments with tailored
          financial products and services.
        </p>
      </div>
      <div id="type" className="container text-center main-div">
        <h1 className="h-tag">Types of Bank </h1>
        <div className="mt-5">
          <Row className="d-flex gap-5 justify-content-center">
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1"  onClick={() => {navigate("/commercialbank");}}>
                <img className="card-img" src={commercial} alt="" />
                <div className="card-body">
                  <Card.Title>Commercial Banks</Card.Title>
                  <Card.Text className="mt-3">
                    Full service banks offering checking and savings accounts,
                    loans, credit cards, and investment services. They serve
                    individuals, businesses, and corporations with comprehensive
                    banking solutions.
                  </Card.Text>
                </div>
              </Card>
            </Col>
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1" onClick={() => {navigate("/investmentbank");}}>
                <img className="card-img" src={invest} alt="" />
                <div className="card-body">
                  <Card.Title>Investment Banks</Card.Title>
                  <Card.Text className="mt-3">
                    Specialized institutions focusing on securities trading,
                    mergers and acquisitions, corporate finance, and capital
                    market services for large corporations and institutional
                    clients.
                  </Card.Text>
                </div>
              </Card>
            </Col>
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1" onClick={() => {navigate("/creditunion");}}>
                <img className="card-img" src={credit} alt="" />
                <div className="card-body">
                  <Card.Title>Credit Unions</Card.Title>
                  <Card.Text className="mt-3">
                    Member owned financial cooperatives providing banking
                    services with typically lower fees and better interest rates
                    compared to traditional banks.
                  </Card.Text>
                </div>
              </Card>
            </Col>

            {/* <Row className="d-flex gap-5 justify-content-center mt-5"> */}
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1" onClick={() => {navigate("/onlinebank");}}>
                <img className="card-img" src={online} alt="" />
                <div className="card-body">
                  <Card.Title>Online Banks</Card.Title>
                  <Card.Text className="mt-3">
                    Digital first financial institutions offering competitive
                    rates and lower fees through online and mobile platforms,
                    without traditional brick and mortar branches.
                  </Card.Text>
                </div>
              </Card>
            </Col>
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1" onClick={() => {navigate("/centralbank");}}>
                <img className="card-img" src={central} alt="" />
                <div className="card-body">
                  <Card.Title>Central Banks</Card.Title>
                  <Card.Text className="mt-3">
                    Government institutions responsible for monetary policy,
                    currency regulation, and oversight of the banking system.
                    Examples include the Federal Reserve, European Central Bank.
                  </Card.Text>
                </div>
              </Card>
            </Col>
            <Col lg={3} md={5} sm={12}>
              <Card className="card card1" onClick={() => {navigate("/communitybank");}}>
                <img className="card-img" src={community} alt="" />
                <div className="card-body">
                  <Card.Title>Community Banks</Card.Title>
                  <Card.Text className="mt-3">
                    Local banks serving specific communities with personalized
                    service, focusing on local business and consumer banking
                    needs.
                  </Card.Text>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <div
        id="core-banking"
        className="main-div2 bank-services d-flex justify-content-between "
      >
        <div className="container ">
          <Row className="pt-5 d-flex align-items-center justify-content-between">
            <Col lg={6} md={12} sm={12} className="">
              <div className="ml-5">
                <Row className="d-flex align-items-center gap-3 con-div">
                  <Col lg={12}>
                    <h1 className="text-white">
                      What Is Core Banking: Definition, Features, Benefits
                    </h1>
                  </Col>
                  <Col lg={5} md={5} sm={12} className="core-img">
                    <img className="img" src={core} alt="" />
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <p style={{ color: "#b0c2d7" }}>
                      Core banking services are centralized systems that manage
                      key banking operations accounts, transactions, and loans
                      while giving real time access across branches and
                      channels.
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col
              lg={5}
              md={12}
              sm={12}
              className="text-center d-flex flex-column gap-4 custom-div"
            >
              <div className="box d-flex gap-3">
                <span className="span">1</span>
                <p className="mb-0 text-start" style={{ fontSize: "20px" }}>
                  Savings, checking, and time deposit accounts
                </p>
              </div>
              <div className="box d-flex gap-3">
                <span className="span">2</span>
                <p className="mb-0 text-start" style={{ fontSize: "20px" }}>
                  Personal loans, mortgages, business loans
                </p>
              </div>
              <div className="box d-flex gap-3">
                <span className="span">3</span>
                <p className="mb-0 text-start" style={{ fontSize: "20px" }}>
                  Wire transfers, ACH, mobile payments
                </p>
              </div>
              <div className="box d-flex gap-3">
                <span className="span">4</span>
                <p className="mb-0 text-start" style={{ fontSize: "20px" }}>
                  Wealth management, securities trading
                </p>
              </div>
              <div className="box d-flex gap-3">
                <span className="span">5</span>
                <p className="mb-0 text-start" style={{ fontSize: "20px" }}>
                  Financial planning, tax preparation
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div id="account-type" className=" text-center main-div bank-type">
        <div className="container">
          <h1 className="h-tag">Bank Account Types </h1>
          <p className="mt-5">
            There are several types of bank accounts designed to meet different
            financial needs. The most common types are savings accounts, current
            accounts, and fixed deposit accounts. Savings accounts are for
            general use and earning interest, while current accounts are for
            frequent transactions, particularly for businesses. Fixed deposit
            accounts offer higher interest rates for money kept for a fixed
            period. Other types include recurring deposit accounts, DEMAT
            accounts, and NRI accounts, each with specific purposes.
          </p>
          <div>
            <Row className="mx-auto">
              {technology.map((item, i) => (
                <Col key={i} lg={4} md={4} sm={6} xs={12} className="mt-5">
                  <Card className="tech-card card1 h-100"  onClick={() => navigate(`/account/${item.id}`)}>
                    <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                      <img src={item.image} alt="" style={{ height: "55px" }} />
                      <h4 className="bold-text mt-3 fw-bold">{item.title}</h4>
                      <p>{item.backContent}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
          <div>
            <img className="d-1" src={dollar} alt="" />
          </div>
          <div>
            <img className="d-2" src={dollar} alt="" />
          </div>
        </div>
      </div>

      <div id="loan" className="container main-div loan-type">
        <h1 className="text-center h-tag">Banking Loans and Credit Products</h1>
        <div className="mt-5">
          <Table striped bordered hover responsive className="custom-table">
            <thead>
              <tr>
                <th>Loan Type</th>
                <th>Purpose</th>
                <th>Term Length</th>
                <th>Interest Rate Type</th>
                <th>Collateral Required</th>
              </tr>
            </thead>
            <tbody>
              {loan.map((item) => (
                <tr key={item.id}>
                  <td>{item.type}</td>
                  <td>{item.purpose}</td>
                  <td>{item.Term}</td>
                  <td>{item.InterestRate}</td>
                  <td>{item.CollateralRequired}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="credit-div">
            <h4 className="h-tag mt-5 fw-bold">
              Credit Products and Lines of Credit
            </h4>
            <p className="mt-4">
              Credit products provide flexible access to funds for various
              purposes. <strong> Credit cards</strong> offer revolving credit
              for daily purchases with rewards and benefits.{" "}
              <strong> Personal lines of credit</strong> provide access to funds
              as needed with interest charged only on amounts used.
            </p>
            <p className="mt-4">
              <strong>Home equity lines of credit (HELOCs) </strong> use home
              equity as collateral for lower interest rates on larger credit
              amounts. Business lines of credit help companies manage cash flow
              and working capital needs.
            </p>
          </div>
          <div className="credit-div">
            <h4 className="h-tag mt-5 fw-bold">Loan Application Process</h4>
            <p className="mt-4">
              The loan application process typically involves credit evaluation,
              income verification, and debt to income ratio assessment. Banks
              consider factors such as credit score, employment history, and
              existing debt obligations when making lending decisions.
            </p>
            <p className="mt-4">
              Pre approval processes allow borrowers to understand their
              borrowing capacity before making major purchases. Digital lending
              platforms have streamlined applications, often providing instant
              decisions for qualified applicants.
            </p>
          </div>
        </div>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      <div id="investment" className="investment mt-5">
        <div className="container inv1  main-div">
          <h1 className="text-center h-tag">Investment Banking Services</h1>
          <div className="d-flex justify-content-center mt-5">
            <img src={investmentbank} className="inv-img" alt="" />
          </div>
          <div>
            <h4 className="mt-5 fw-bold">Investment Services Overview</h4>
            <p className="mt-3">
              Banks provide comprehensive investment services ranging from basic
              brokerage accounts to sophisticated wealth management solutions.
              These services help clients build and preserve wealth through
              diversified investment portfolios.
            </p>
            <p className="mt-4">
              Investment banks play a crucial role in raising capital for
              businesses through initial public offerings (IPOs), bond
              issuances, and private placements. They also assist in risk
              management through derivatives trading and provide market research
              and analysis to guide investment decisions.
            </p>
          </div>
          <div>
            <Row className="mx-auto">
              {investment.map((item, i) => (
                <Col key={i} lg={4} md={4} sm={6} xs={12} className="mt-5">
                  <Card className="tech-card card1 h-100" onClick={() => navigate(`/investment/${item.id}`)}>
                    <Card.Body className="d-flex flex-column gap-3 align-items-center justify-content-center">
                      {/* <img src={item.image} alt="" style={{ height: "55px" }} /> */}
                      <h4 className="bold-text mt-3 fw-bold">{item.title}</h4>
                      <p className="text-center">{item.backContent}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
          <div className="mt-5">
            <h4 className="fw-bold">Investment Products and Solutions</h4>
            <p className="mt-3">
              Banks offer diverse investment products including mutual funds,
              exchange traded funds (ETFs), bonds, and structured products.
              These products cater to different risk tolerances and investment
              objectives.
            </p>
            <p className="mt-3">
              Alternative investments such as real estate investment trusts
              (REITs), commodities, and hedge funds provide diversification
              opportunities for qualified investors.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="carousel-container margin-top">
          {/* Static Background */}
          <div className="carousel-background"></div>

          {/* Carousel with Content */}
          <div className="carousel-content">
            <Carousel controls={true} indicators={true} interval={4000}>
              <Carousel.Item>
                <div className="carousel-item-content">
                  <div className="d-flex align-items-center gap-3">
                    <span>
                      <img src={phone} style={{ height: "26px" }} alt="" />
                    </span>
                    <h3> All Bank Balance</h3>
                  </div>
                  <p className="lead mt-2 banner-text">
                    {" "}
                    Check All Bank Balance At One Place.
                  </p>
                </div>
              </Carousel.Item>

              <Carousel.Item>
                <div className="carousel-item-content ">
                  <div className="d-flex align-items-center gap-3">
                    <span>
                      <img
                        src={notepad}
                        className="custom-img"
                        style={{ height: "26px" }}
                        alt=""
                      />
                    </span>{" "}
                    <h3>Bank Statement</h3>
                  </div>
                  <p className="lead mt-2 banner-text">
                    Bank Passbook Without Login And Net .
                  </p>
                </div>
              </Carousel.Item>

              <Carousel.Item>
                <div className="carousel-item-content ">
                  <div className="d-flex align-items-center gap-3">
                    <span>
                      <img src={mobile} style={{ height: "36px" }} alt="" />{" "}
                    </span>{" "}
                    <h3> All In One Mobile Banking</h3>
                  </div>
                  <p className="lead mt-2 banner-text">
                    Bank Holiday,EMI Calculator And More.
                  </p>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
      <div id="digital-banking" className="container digital-banking  main-div">
        <h1 className="text-center h-tag">Digital Banking</h1>
        <div className="main-content">
        <div>
        <h4 className="mt-5 ">Digital Banking Revolution</h4>
        <p>
          Digital banking has transformed how customers interact with financial
          institutions. Mobile banking apps, online platforms, and digital only
          banks provide 24/7 access to banking services with enhanced
          convenience and functionality.
        </p>
        </div>
        <div>
        <h4 className="">Mobile Banking Features</h4>
        <p>
          Modern mobile banking apps offer comprehensive functionality including
          account management, bill payment, money transfers, check deposits, and
          budget tracking. Advanced features include biometric authentication,
          voice banking, and AI powered financial insights.
        </p>
        <p>
          Contactless payment technologies, including NFC payments, QR code
          transactions, and digital wallets, have revolutionized point of sale
          experiences and peer to peer transfers.
        </p>
        </div>
        <div>
        <h4 className="">Fintech Integration</h4>
        <p>
          Banks increasingly partner with fintech companies to provide
          innovative services such as robo advisors for automated investing,
          personal financial management tools, and alternative lending
          solutions.
        </p>
        <p>
          Open banking initiatives enable third party financial service
          providers to access bank data (with customer consent) to create
          personalized financial products and services.
        </p>
        </div>
        <div>
        <h4 className="">Cybersecurity and Digital Safety</h4>
        <p>
          Banks implement robust cybersecurity measures including multi factor
          authentication, encryption, fraud monitoring, and real time
          transaction alerts. Customer education on digital safety practices is
          crucial for maintaining security in digital banking environments.
        </p>
        <p>
          Regulatory compliance frameworks such as PCI DSS, GDPR, and Open
          Banking standards ensure data protection and consumer privacy in
          digital financial services.
        </p>
        </div>
        </div>
        <img className="coin1" src={coin} alt="" />
        <img className="coin2" src={coin} alt="" />
      </div>
      <div className="container banking main-div">
        <h1 className="h-tag text-center">Banking Regulations</h1>
        <div className="main-content">
        <div>
        <h4 className="mt-5 ">Regulatory Framework</h4>
        <p>
          Banking regulations ensure financial system stability, protect
          consumers, and maintain fair competition. Key regulatory bodies
          include the Federal Reserve, FDIC, OCC, and CFPB in the United States,
          with similar institutions worldwide.
        </p>
        </div>
        <div>
        <h4 className="mt-4 ">Consumer Protection Laws</h4>
        <p>
          Important consumer protection regulations include the Fair Credit
          Reporting Act, Truth in Lending Act, Fair Debt Collection Practices
          Act, and Electronic Fund Transfer Act. These laws establish rights and
          protections for banking customers.
        </p>
        <p>
          Deposit insurance through programs like FDIC coverage protects
          customer deposits up to specified limits, providing confidence in the
          banking system's stability.
        </p>
        </div>
        <div>
        <h4 className="mt-4 ">Compliance and Risk Management</h4>
        <p>
          Banks maintain comprehensive compliance programs addressing anti money
          laundering (AML), know your customer (KYC) requirements, and risk
          management protocols. These programs protect both institutions and
          customers from financial crimes.
        </p>
        </div>
        </div>
        <img className="rupee1" src={rupee} alt="" />
        <img className="rupee2" src={rupee} alt="" />
      </div>
      <div className="container main-div future-banking">
        <h1 className="h-tag text-center">Future of Banking</h1>
        <div>
          <h4 className="mt-5 ">Emerging Technologies</h4>
          <p className="mt-3">
            The banking industry continues evolving with emerging technologies
            including <strong> artificial intelligence</strong>,{" "}
            <strong>blockchain </strong> , <strong> quantum computing </strong>,
            and <strong> Internet of Things (IoT) </strong> applications.
          </p>
          <p>
            Central bank digital currencies (CBDCs) represent potential future
            developments in monetary systems, combining digital convenience with
            regulatory oversight.
          </p>
          <h4 className="mt-5 ">Sustainable Banking</h4>
          <p className="mt-3">
            Environmental, social, and governance (ESG) considerations
            increasingly influence banking practices.{" "}
            <strong>Green banking initiatives</strong> ,{" "}
            <strong> sustainable financing </strong>, and{" "}
            <strong>responsible investing </strong> reflect growing emphasis on
            sustainability.
          </p>
          <p>
            Banks are developing products and services that support
            environmental goals, including green bonds, sustainable loans, and
            carbon footprint tracking tools.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
